export default __webpack_public_path__ + "static/media/manrope-thin.4d40c2cf.woff";